import { Observable } from 'rxjs';
import { distinctUntilChanged, share } from 'rxjs/operators';
var ifvisible = require('ifvisible.js');

/**
 * Determines if an element is visible in the viewport.
 *
 * @param element
 * @param percentX
 * @param percentY
 * @returns {boolean}
 */
export function inView(element, percentX, percentY) {
  var tolerance = 0.01; // needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
  if (percentX == null) {
    percentX = 100;
  }
  if (percentY == null) {
    percentY = 100;
  }
  var elementRect = element.getBoundingClientRect();
  var parentRects = [];
  while (element.parentElement != null) {
    parentRects.push(element.parentElement.getBoundingClientRect());
    element = element.parentElement;
  }
  return parentRects.every(function (parentRect) {
    var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
    var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);
    var visiblePercentageX = visiblePixelX / elementRect.width * 100;
    var visiblePercentageY = visiblePixelY / elementRect.height * 100;
    percentY = elementRect.height > parentRect.height ? parentRect.height / elementRect.height * 100 : 100;
    return visiblePercentageX + tolerance > percentX && visiblePercentageY + tolerance > percentY;
  });
}
export var PageActivity = {
  Active: 'active',
  Inactive: 'inactive',
  Exit: 'exit'
};
var pageActivity$ = new Observable(function (observer) {
  var onActive = function onActive() {
    return observer.next(PageActivity.Active);
  };
  var onInactive = function onInactive() {
    return observer.next(PageActivity.Inactive);
  };
  var onExit = function onExit() {
    return observer.next(PageActivity.Exit);
  };
  ifvisible.on('focus', function () {
    return observer.next(PageActivity.Active);
  });
  ifvisible.on('wakeup', function () {
    return observer.next(PageActivity.Active);
  });
  ifvisible.on('blur', function () {
    return observer.next(PageActivity.Inactive);
  });
  ifvisible.on('idle', function () {
    return observer.next(PageActivity.Inactive);
  });
  window.addEventListener('beforeunload', onExit);
  return function () {
    ifvisible.off('focus', onActive);
    ifvisible.off('wakeup', onActive);
    ifvisible.off('blur', onInactive);
    ifvisible.off('idle', onInactive);
    window.removeEventListener('beforeunload', onExit);
  };
}).pipe(distinctUntilChanged(), share());

/**
 * Gets a stream for page visibility.
 */
export function pageActivityStream() {
  return pageActivity$;
}
//# sourceMappingURL=domUtil.js.map
